import React, { useContext, useState } from "react";
import "./Adds.scss";
// owl carasoul work end
import { Skeleton } from "@material-ui/lab";
import { useLocation, useParams } from "react-router-dom";
import StateContext from "../../StateContext";
import Axios from 'axios'
import { handleError } from "../../Functions/getAlert";
import DispatchContext from "../../DispatchContext";

const Adds = (props) => {
  const { data, addsObjLength } = props;
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [bId] = useState(searchParams.get("bId"));
  const [isLoading, setIsLoading] = useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);


  const handleClickAdds = async(link) => {
    setIsLoading(true);

    try {
      const response = await Axios.get(
        `${link}`,
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      // appDispatch({type: "DetailsAdd", allDetails: response.data.data, loading: false})
      setIsLoading(false);
    } catch (e) {
      // handleError(e, appDispatch);
      setIsLoading(false);

    }


    // const response = await axios.get(
    //   `${link}`,
    
    //   {
    //     headers: {
    //       Authorization: `Bearer ${appState.token}`,
    //     },
    //   }
    // );
    // console.log(response);
    setIsLoading(false);
  } 
  return (
    <div
    // id={styles?.wrapperStoreList}
    >
      {isLoading ? (
        <React.Fragment>
          <div className="kanwar row m-0 mb-4 mt-3 d-flex flex-row">
            <div className="col-6  ">
              <Skeleton height={50} />
            </div>
            <div className="col-10 ">
              <Skeleton height={50} />
            </div>
            <div className="col-3 ">
              <Skeleton height={50} />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          id="AddsInfo"
          className={`w-100  ${
            appState?.langValue === "ar"
              ? `directionRt classForArabicReOrderMain`
              : ""
          } ${appState?.langValue == "ar" ? "arabicFamilyParent" : " "}   `}
        >
          {/* <Navbar showBackBtn={false} /> */}

          <div
            className={`row mb-3    `}
          >
            <div className={`owl_item black col-12 px-0`}>
              <a className="cursor-pointer" href={` ${!appState.loggedIn ? `${data?.click_link}?customer=321` : data?.click_link }`}>
                {" "}
                <span className="card-item">
                  <section id={`Products`}>
                    <div
                      id={`category_`}
                      // id={`category_${category.name.split(" ").join("")}`}
                      className="w-100"
                    >
                      <div className={`inner_prod`}>
                        <span>
                          <div
                            // className={`${styles?.prdCard} d-flex align-items-end  w-100`}
                            className="prdCard px-3 d-flex flex-column justify-content-end"
                            style={{
                              background: `url(${
                                data?.content != null
                                  ? `${data?.content}`
                                  : `./Rectangle_16965.png`
                              }) center center / cover no-repeat`
                            }}
                          >
                            {/* <div
                              className={`my-3  d-flex justify-content-between  ${
                                appState?.langValue === "ar"
                                  ? `storeNameArabic`
                                  : `storeName`
                              } `}
                            >
                              <span
                                className={`d-flex align-items-center ${
                                  appState.langValue === "ar"
                                    ? `direction-ltrt`
                                    : ""
                                }`}
                              >
                                <h1
                                  className={`reOrderheading primary-text familysora700   textOver  px-2 m-0  ${
                                    appState?.langValue === "ar"
                                      ? "text-right"
                                      : "text-left"
                                  }`}
                                >
                                  {data?.name}
                                </h1>
                              </span>
                            </div> */}
                            {/* <hr/> */}
                          </div>
                        </span>
                      </div>
                    </div>
                  </section>
                </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Adds;
